import withMinorEligibility from 'hoc/withMinorEligibility';
import withSelectedPatientInfo from '../../hoc/withSelectedPatientInfo';
import withRoles from '../../hoc/withRoles';
import PatientInfo from './PatientInfo';

export default withRoles(withSelectedPatientInfo(withMinorEligibility(PatientInfo)));
